import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, List } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Typography as SwagupTypography } from '@swagup-com/components';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import { Link } from '../shared';
import { scrollBar } from '../shared/styles/commonStyles';

const useStyles = makeStyles({
  root: {
    minWidth: 250,
    padding: 0
  },
  item: {
    padding: '10px 12px',
    borderRadius: 12,
    gap: 18,
    flexWrap: 'nowrap',
    '&:hover': {
      padding: '10px 12px',
      cursor: 'pointer',
      backgroundColor: '#f7f8fa',
      borderRadius: 12
    }
  },
  scrollBar: {
    '&, & *': {
      ...scrollBar
    }
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    padding: 12,
    backgroundColor: '#E9F2FF',
    borderRadius: 12
  }
});

const HeaderMenuItemContent = ({ title, description, imageSrc, isActive = false }) => {
  const classes = useStyles();

  return (
    <Grid
      className={classes.item}
      direction="row"
      justifyContent="flex-start"
      alignItems={description ? 'flex-start' : 'center'}
      container
    >
      <Grid item className={classes.icon}>
        <img style={{ maxWidth: '20px' }} src={imageSrc} alt={title} />
      </Grid>
      <Grid container item style={{ flexDirection: 'column' }}>
        <SwagupTypography color="textPrimary" variant="subtitle3SemiBold">
          {title}
        </SwagupTypography>
        {description && (
          <SwagupTypography style={{ color: '#4A4F54' }} variant="body3RegularInter">
            {description}
          </SwagupTypography>
        )}
      </Grid>
    </Grid>
  );
};

const HeaderMenu = ({ menuItemList }) => {
  const classes = useStyles();

  return (
    <>
      {menuItemList.map(({ path, absolute, onClick, as, ...contentProps }) =>
        onClick ? (
          <div role="presentation" onClick={onClick} className={classes.root} key={contentProps.title}>
            <HeaderMenuItemContent {...contentProps} isActive />
          </div>
        ) : (
          <Link to={path} absolute={absolute} className={classes.root} key={contentProps.title} as={as}>
            <HeaderMenuItemContent {...contentProps} />
          </Link>
        )
      )}
    </>
  );
};

export const ListMenu = ({ menuItems = [], bottomItem, bottomItemSeparation = 200 }) => (
  <List component="nav">
    {menuItems.map(({ title, subItems, onClick, path, absolute }) =>
      subItems ? (
        <ExpandableListItem key={title} title={title} subItems={subItems} />
      ) : (
        <Link style={{ color: 'white' }} to={path} absolute={absolute} key={title}>
          <ClickableListItem style={{ color: 'white' }} title={title} onClick={onClick} />
        </Link>
      )
    )}
    {bottomItem && (
      <ClickableListItem
        style={{ marginTop: bottomItemSeparation, cursor: 'pointer' }}
        title={bottomItem.title}
        onClick={bottomItem.onClick}
      />
    )}
  </List>
);

const ClickableListItem = ({ onClick, title, style }) => (
  <ListItem component="div" role="presentation" style={style} onClick={onClick}>
    <ListItemText>
      <Typography variant="h5" color="inherit">
        {title}
      </Typography>
    </ListItemText>
  </ListItem>
);

const ExpandableListItem = ({ title, subItems }) => {
  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <>
      <ListItem button onClick={toggleOpen}>
        <ListItemText style={{ cursor: 'pointer' }}>
          <Typography variant="h5" color="inherit">
            {`${title} ${open ? '-' : '+'}`}
          </Typography>
        </ListItemText>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {subItems.map(item => (
          <List key={item.title} component="div" disablePadding>
            <ListItem onClick={item.onClick} component={Link} absolute={item.absolute} to={item.path}>
              <ListItemIcon>
                <img style={{ borderRadius: 5, backgroundColor: '#FFFFFF' }} src={item.imageSrc} alt={title} />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="button" style={{ color: '#FFFFFF' }}>
                  {item.title}
                </Typography>
              </ListItemText>
            </ListItem>
          </List>
        ))}
      </Collapse>
    </>
  );
};

export default HeaderMenu;
